import { render, staticRenderFns } from "./VaultMenu.vue?vue&type=template&id=f8cf7f0c&scoped=true&"
import script from "./VaultMenu.vue?vue&type=script&lang=ts&"
export * from "./VaultMenu.vue?vue&type=script&lang=ts&"
import style0 from "./VaultMenu.vue?vue&type=style&index=0&id=f8cf7f0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cf7f0c",
  null
  
)

export default component.exports